import React, {Component} from 'react';
import "../../../../style/registerPage.css";
import StepProgressBar from 'react-step-progress';
import 'react-step-progress/dist/index.css';

import CInformationPage from "./ConstantResident/CInformationPage";
import CInformationFurtherPage from "./ConstantResident/CInformationFurtherPage";
import CInformationFamilyPage from "./ConstantResident/CInformationFamilyPage";
import CUploadPage from "./ConstantResident/CUploadPage";

import FGInformationPage from "./FamilyGuest/FGInformationPage";
import FGInformationFurtherPage from "./FamilyGuest/FGInformationFurtherPage";
import FGInformationFamilyPage from "./FamilyGuest/FGInformationFamilyPage";
import FGUploadPage from "./FamilyGuest/FGUploadPage";

import OGInformationPage from "./OtherGuest/OGInformationPage";
import OGInformationFurtherPage from "./OtherGuest/OGInformationFurtherPage";
import OGInformationFamilyPage from "./OtherGuest/OGInformationFamilyPage";
import OGUploadPage from "./OtherGuest/OGUploadPage";

import BuildingContext from '../../../../contexts/Building';
import {Modal} from "react-bootstrap";
import {BsCheckCircle, BsCheckCircleFill} from "react-icons/bs";
import {Link} from "react-router-dom";
import axios from "axios";
import {FormControl, MenuItem, Select} from "@mui/material";
import {toast, ToastContainer} from "react-toastify";
import {CSSTransition} from "react-transition-group";
import { API_BASE_URL } from '../../../../api/client';
import { isOptionalNumber, isRequiredNumber, normalizeNumericInput } from '../../../../utils/persianDate';
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';


class MainRegister extends Component {

    constructor(props) {
        super(props);
        this.constantCheck = React.createRef();
        this.familyGuestCheck = React.createRef();
        this.otherGuestCheck = React.createRef();
    }

    goHome = () => {
        this.props.history.push('/Register')
    }

    static contextType = BuildingContext;

    //######################################################## first pages
    constantInformationPageValidation = () => {
        let requiredReg = /^\s*$/;

        let firstName_requiredReg = !requiredReg.test(this.context.constantInformationPage.firstName);
        let lastName_requiredReg = !requiredReg.test(this.context.constantInformationPage.lastName);
        let nationalCode_requiredReg = !requiredReg.test(this.context.constantInformationPage.nationalCode);
        let certificateNumber_requiredReg = true;
        let placeOfIssue_requiredReg = !requiredReg.test(this.context.constantInformationPage.placeOfIssue);
        let birthDate_requiredReg = true;
        let nationality_requiredReg = true;
        let fatherName_requiredReg = !requiredReg.test(this.context.constantInformationPage.fatherName);
        let spouseFullName_requiredReg = true;
        let healthyStatus_requiredReg = true;

        let nationalCode_numberReg = isRequiredNumber(this.context.constantInformationPage.nationalCode);
        let certificateNumber_numberReg = isOptionalNumber(this.context.constantInformationPage.certificateNumber);
        let studentNumber_numberReg = isOptionalNumber(this.context.constantInformationPage.studentNumber);

        this.context.handleSpecificValidations([firstName_requiredReg, lastName_requiredReg, nationalCode_requiredReg, certificateNumber_requiredReg,
                placeOfIssue_requiredReg, birthDate_requiredReg, nationality_requiredReg, fatherName_requiredReg, spouseFullName_requiredReg,
                healthyStatus_requiredReg, nationalCode_numberReg, certificateNumber_numberReg, studentNumber_numberReg],
            ['firstName_requiredReg', 'lastName_requiredReg', 'nationalCode_requiredReg', 'certificateNumber_requiredReg',
                'placeOfIssue_requiredReg', 'birthDate_requiredReg', 'nationality_requiredReg', 'fatherName_requiredReg', 'spouseFullName_requiredReg',
                'healthyStatus_requiredReg', 'nationalCode_numberReg', 'certificateNumber_numberReg', 'studentNumber_numberReg'], 'constantInformationPageValidation');

        return firstName_requiredReg && lastName_requiredReg && nationalCode_requiredReg &&
            placeOfIssue_requiredReg && fatherName_requiredReg &&
            nationalCode_numberReg && certificateNumber_numberReg && studentNumber_numberReg;
    }

    familyGuestValidation = () => {

        let requiredReg = /^\s*$/;

        let firstName_requiredReg = !requiredReg.test(this.context.familyGuestInformation.firstName);
        let lastName_requiredReg = !requiredReg.test(this.context.familyGuestInformation.lastName);
        let nationalCode_requiredReg = !requiredReg.test(this.context.familyGuestInformation.nationalCode);
        let certificateNumber_requiredReg = true;
        let startDate_requiredReg = true;
        let endDate_requiredReg = true;
        let paymentDate_requiredReg = !requiredReg.test(this.context.familyGuestInformation.paymentDate);
        let birthDate_requiredReg = !requiredReg.test(this.context.familyGuestInformation.birthDate);
        let depositReturnDate_requiredReg = true;

        let rentPaymentAmount_numberReg = isOptionalNumber(this.context.familyGuestInformation.rentPaymentAmount);
        let depositPaymentAmount_numberReg = isOptionalNumber(this.context.familyGuestInformation.depositPaymentAmount);
        let discountPaymentAmount_numberReg = isOptionalNumber(this.context.familyGuestInformation.discountPaymentAmount);
        let nationalCode_numberReg = isRequiredNumber(this.context.familyGuestInformation.nationalCode);
        let certificateNumber_numberReg = isOptionalNumber(this.context.familyGuestInformation.certificateNumber);


        this.context.handleSpecificValidations([firstName_requiredReg, lastName_requiredReg, nationalCode_requiredReg, certificateNumber_requiredReg,
                startDate_requiredReg, endDate_requiredReg, paymentDate_requiredReg, birthDate_requiredReg, depositReturnDate_requiredReg,
                rentPaymentAmount_numberReg, depositPaymentAmount_numberReg, discountPaymentAmount_numberReg, nationalCode_numberReg, certificateNumber_numberReg,],
            ['firstName_requiredReg', 'lastName_requiredReg', 'nationalCode_requiredReg', 'certificateNumber_requiredReg',
                'startDate_requiredReg', 'endDate_requiredReg', 'paymentDate_requiredReg', 'birthDate_requiredReg', 'depositReturnDate_requiredReg',
                'rentPaymentAmount_numberReg', 'depositPaymentAmount_numberReg', 'discountPaymentAmount_numberReg',
                'nationalCode_numberReg', 'certificateNumber_numberReg'], 'familyGuestInformationValidation');

        return firstName_requiredReg && lastName_requiredReg && nationalCode_requiredReg &&
            birthDate_requiredReg && paymentDate_requiredReg &&
            nationalCode_numberReg && certificateNumber_numberReg &&
            rentPaymentAmount_numberReg && depositPaymentAmount_numberReg && discountPaymentAmount_numberReg;
    }
    componentDidMount() {
        let typeOfResident = <div className='typeofResident'>
            <div className="mt-2 w-100 mx-3">
                <h5 className="mb-5">نوع اقامتگر</h5>
                <div className="constant-container">
                    <label className="radio-container">
                        اقامتگر ثابت
                        <input type="radio"  name="register-radio" value="constant"
                               checked={this.state.constantCheck}
                               onChange={(e) => {
                                   this.setState({isConstant: true})
                                   this.checked(e); this.context.handleTypeofResident('constant')}}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                <div className="guest-container d-flex w-100 flex-column mt-0">
                    <div className={"d-flex mt-0"}>
                        <label className="radio-container mt-2 mb-3">
                            مهمان
                            <input type={"radio"} name="register-radio" value={"familyGuest"}
                                   checked={!this.state.isConstant}
                                   disabled={!this.state.constantCheck}
                                   onChange={(e) => {
                                       this.setState({isConstant: false})
                                       this.checked(e)
                                   }}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                    <div className={"justify-content-start flex-column mx-5 mb-2 mt-0"} style={{display: this.state.constantCheck ? "none" : "flex"}}>
                        <label className="radio-container">
                            بستگان درجه یک
                            <input type="radio"  name="radio" value={"familyGuest"}
                                   checked={this.state.familyGuestCheck}
                                   onChange={(e) => {
                                       this.checked(e)
                                   }}
                            />
                            <span className="checkmark"></span>
                        </label>
                        <label className="radio-container">
                            متفرقه
                            <input type="radio"  name="radio" value={"otherGuest"}
                                   checked={this.state.otherGuestCheck}
                                   onChange={(e) => {
                                       this.checked(e)
                                   }}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        let updatedState = [...this.state.steps];
        updatedState[0].content = typeOfResident;
        this.setState({step:updatedState})
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.constantCheck !== this.state.constantCheck || prevState.otherGuestCheck !== this.state.otherGuestCheck || prevState.familyGuestCheck !== this.state.familyGuestCheck){
            let typeOfResident = <div className='typeofResident'>
                <div className="mt-2 w-100 mx-3">
                    <h5 className="mb-5">نوع اقامتگر</h5>
                    <div className="constant-container">
                        <label className="radio-container">
                            اقامتگر ثابت
                            <input type="radio"  name="register-radio" value="constant"
                                   checked={this.state.constantCheck}
                                   onChange={(e) => {
                                       this.setState({isConstant: true})
                                       this.checked(e); this.context.handleTypeofResident('constant')}}
                            />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                    <div className="guest-container d-flex flex-column w-100 mt-0">
                        <div className={"d-flex mt-0"}>
                            <label className="radio-container mb-3 mt-2">
                                مهمان
                                <input type={"radio"} name="register-radio" value={"familyGuest"}
                                       checked={!this.state.isConstant}
                                       disabled={!this.state.constantCheck}
                                       onChange={(e) => {
                                           this.setState({isConstant: false})
                                           this.checked(e)
                                       }}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className={"justify-content-start flex-column mt-0 mx-5"} style={{display: this.state.constantCheck ? "none" : "flex"}}>
                            <label className="radio-container">
                                بستگان درجه یک
                                <input type="radio"  name="radio" value={"familyGuest"}
                                       checked={this.state.familyGuestCheck}
                                       onChange={(e) => {
                                           this.checked(e)
                                       }}
                                />
                                <span className="checkmark"></span>
                            </label>
                            <label className="radio-container">
                                متفرقه
                                <input type="radio"  name="radio" value={"otherGuest"}
                                       checked={this.state.otherGuestCheck}
                                       onChange={(e) => {
                                           this.checked(e)
                                       }}
                                />
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            let updatedState = [...this.state.steps];
            updatedState[0].content = typeOfResident;
            this.setState({step:updatedState})
        }
    }

    otherGuestValidation = () => {
        let requiredReg = /^\s*$/;

        let firstName_requiredReg = !requiredReg.test(this.context.otherGuestInformation.firstName);
        let lastName_requiredReg = !requiredReg.test(this.context.otherGuestInformation.lastName);
        let nationalCode_requiredReg = !requiredReg.test(this.context.otherGuestInformation.nationalCode);
        let certificateNumber_requiredReg = true;
        let startDate_requiredReg = true;
        let endDate_requiredReg = true;
        let birthDate_requiredReg = !requiredReg.test(this.context.otherGuestInformation.birthDate);
        let depositReturnDate_requiredReg = true;
        let paymentDate_requiredReg = !requiredReg.test(this.context.otherGuestInformation.paymentDate);

        let nationalCode_numberReg = isRequiredNumber(this.context.otherGuestInformation.nationalCode);
        let certificateNumber_numberReg = isOptionalNumber(this.context.otherGuestInformation.certificateNumber);
        let rentPaymentAmount_numberReg = isOptionalNumber(this.context.otherGuestInformation.rentPaymentAmount);
        let depositPaymentAmount_numberReg = isOptionalNumber(this.context.otherGuestInformation.depositPaymentAmount);
        let discountPaymentAmount_numberReg = isOptionalNumber(this.context.otherGuestInformation.discountPaymentAmount);

        this.context.handleSpecificValidations([firstName_requiredReg, lastName_requiredReg, nationalCode_requiredReg, certificateNumber_requiredReg,
                startDate_requiredReg, endDate_requiredReg, birthDate_requiredReg, depositReturnDate_requiredReg, paymentDate_requiredReg,
                nationalCode_numberReg, certificateNumber_numberReg,
                rentPaymentAmount_numberReg, depositPaymentAmount_numberReg, discountPaymentAmount_numberReg],
            ['firstName_requiredReg', 'lastName_requiredReg', 'nationalCode_requiredReg', 'certificateNumber_requiredReg',
                'startDate_requiredReg', 'endDate_requiredReg', 'birthDate_requiredReg', 'depositReturnDate_requiredReg', 'paymentDate_requiredReg',
                'nationalCode_numberReg', 'certificateNumber_numberReg',
                'rentPaymentAmount_numberReg', 'depositPaymentAmount_numberReg', 'discountPaymentAmount_numberReg'], 'otherGuestInformationValidation');

        return firstName_requiredReg && lastName_requiredReg && nationalCode_requiredReg &&
            birthDate_requiredReg && paymentDate_requiredReg &&
            nationalCode_numberReg && certificateNumber_numberReg &&
            rentPaymentAmount_numberReg && depositPaymentAmount_numberReg && discountPaymentAmount_numberReg;
    }



    //######################################################## second pages
    cInformationFurtherPageValidation = () => {
        let requiredReg = /^\s*$/;
        let telephoneReg = /^09\d{9}$/; // iranian telephone number '09---------'
        let homeTelephoneReg = /^0\d{7,10}$/;

        let address_requiredReg = true;

        let telephoneNumber_requiredReg = true;
        // Home phone optional; format applies only when a value is present.
        let telephoneNumber_homeTelephoneReg = requiredReg.test(this.context.constantInformationFurther.telephoneNumber)
            || homeTelephoneReg.test(this.context.constantInformationFurther.telephoneNumber);

        let phoneNumber_requiredReg = !requiredReg.test(this.context.constantInformationFurther.phoneNumber);
        let phoneNumber_telephoneReg = telephoneReg.test(this.context.constantInformationFurther.phoneNumber);

        let startDate_requiredReg = true;
        let endDate_requiredReg = true;
        let depositReturnDate_requiredReg = true;

        this.context.handleSpecificValidations([address_requiredReg, telephoneNumber_requiredReg, telephoneNumber_homeTelephoneReg,
                phoneNumber_requiredReg, phoneNumber_telephoneReg, startDate_requiredReg, endDate_requiredReg, depositReturnDate_requiredReg],
            ['address_requiredReg', 'telephoneNumber_requiredReg', 'telephoneNumber_homeTelephoneReg', 'phoneNumber_requiredReg',
                'phoneNumber_telephoneReg', 'startDate_requiredReg', 'endDate_requiredReg', 'depositReturnDate_requiredReg'], 'constantInformationFurtherValidation');

        return telephoneNumber_homeTelephoneReg && phoneNumber_requiredReg && phoneNumber_telephoneReg;
    }

    fgInformationFurtherPageValidation = () => {
        let requiredReg = /^\s*$/;
        let telephoneReg = /^09\d{9}$/; // iranian telephone number '09---------'
        let homeTelephoneReg = /^0\d{7,10}$/;

        let address_requiredReg = true;

        let telephoneNumber_requiredReg = true;
        let telephoneNumber_homeTelephoneReg = requiredReg.test(this.context.familyGuestInformationFurther.telephoneNumber)
            || homeTelephoneReg.test(this.context.familyGuestInformationFurther.telephoneNumber);

        let phoneNumber_requiredReg = true;
        let phoneNumber_telephoneReg = requiredReg.test(this.context.familyGuestInformationFurther.phoneNumber)
            || telephoneReg.test(this.context.familyGuestInformationFurther.phoneNumber);

        this.context.handleSpecificValidations([address_requiredReg, telephoneNumber_requiredReg, telephoneNumber_homeTelephoneReg,
                phoneNumber_requiredReg, phoneNumber_telephoneReg],
            ['address_requiredReg', 'telephoneNumber_requiredReg', 'telephoneNumber_homeTelephoneReg', 'phoneNumber_requiredReg',
                'phoneNumber_telephoneReg'], 'familyGuestInformationFurtherValidation');

        return telephoneNumber_homeTelephoneReg && phoneNumber_telephoneReg;
    }

    ogInformationFurtherPageValidation = () => {
        let requiredReg = /^\s*$/;
        let telephoneReg = /^09\d{9}$/; // iranian telephone number '09---------'
        let homeTelephoneReg = /^0\d{7,10}$/;

        let address_requiredReg = true;

        let telephoneNumber_requiredReg = true;
        let telephoneNumber_homeTelephoneReg = requiredReg.test(this.context.otherGuestInformationFurther.telephoneNumber)
            || homeTelephoneReg.test(this.context.otherGuestInformationFurther.telephoneNumber);

        let phoneNumber_requiredReg = true;
        let phoneNumber_telephoneReg = requiredReg.test(this.context.otherGuestInformationFurther.phoneNumber)
            || telephoneReg.test(this.context.otherGuestInformationFurther.phoneNumber);

        this.context.handleSpecificValidations([address_requiredReg, telephoneNumber_requiredReg, telephoneNumber_homeTelephoneReg,
                phoneNumber_requiredReg, phoneNumber_telephoneReg],
            ['address_requiredReg', 'telephoneNumber_requiredReg', 'telephoneNumber_homeTelephoneReg', 'phoneNumber_requiredReg',
                'phoneNumber_telephoneReg'], 'otherGuestInformationFurtherValidation');

        return telephoneNumber_homeTelephoneReg && phoneNumber_telephoneReg;
    }


    //######################################################## third pages
    cInformationFamilyPageValidation = () => {
        let requiredReg = /^\s*$/;
        let telephoneReg = /^09\d{9}$/;

        let firstPersonFullName_requiredReg = true;
        let firstPersonPhoneNumber_requiredReg = true;
        let secondPersonFullName_requiredReg = true;
        let secondPersonPhoneNumber_requiredReg = true;

        let firstPersonPhoneNumber_telephoneReg = requiredReg.test(this.context.constantInformationFamily.firstPersonPhoneNumber)
            || telephoneReg.test(this.context.constantInformationFamily.firstPersonPhoneNumber);
        let secondPersonPhoneNumber_telephoneReg = requiredReg.test(this.context.constantInformationFamily.secondPersonPhoneNumber)
            || telephoneReg.test(this.context.constantInformationFamily.secondPersonPhoneNumber);

        let thirdPersonPhoneNumber_telephoneReg = requiredReg.test(this.context.constantInformationFamily.thirdPersonPhoneNumber)
            || telephoneReg.test(this.context.constantInformationFamily.thirdPersonPhoneNumber);

        this.context.handleSpecificValidations([firstPersonFullName_requiredReg, firstPersonPhoneNumber_requiredReg,
            secondPersonFullName_requiredReg, secondPersonPhoneNumber_requiredReg, firstPersonPhoneNumber_telephoneReg,
            secondPersonPhoneNumber_telephoneReg, thirdPersonPhoneNumber_telephoneReg], ['firstPersonFullName_requiredReg', 'firstPersonPhoneNumber_requiredReg',
            'secondPersonFullName_requiredReg', 'secondPersonPhoneNumber_requiredReg', 'firstPersonPhoneNumber_telephoneReg',
            'secondPersonPhoneNumber_telephoneReg', 'thirdPersonPhoneNumber_telephoneReg'], 'constantInformationFamilyValidation');

        return firstPersonPhoneNumber_telephoneReg &&
            secondPersonPhoneNumber_telephoneReg && thirdPersonPhoneNumber_telephoneReg;
    }

    fgThirdPage = () => {
        const hostId = this.context.familyGuestInformationFamily?.hostId;
        const hostId_requiredReg = !!(hostId && String(hostId).trim());
        this.context.handleSpecificValidations(
            [hostId_requiredReg],
            ['hostId_requiredReg'],
            'familyGuestInformationFamilyValidation'
        );
        return hostId_requiredReg;
    }

    ogThirdPage = () => {
        return true;
    }

    fgInformationFamilyPageValidation = () => {

    }

    ogInformationFamilyPageValidation = () => {

    }

    state = {

        steps: [
            {
                label: 'نوع اقامتگر',
                name: 'step 1',
                content: "",
            },
            {
                label: 'مشخصات اولیه',
                name: 'step 1',
                content: <CInformationPage />,
                validator: this.constantInformationPageValidation,
            },
            {
                label: 'مشخصات تکمیلی',
                name: 'step 2',
                content: <CInformationFurtherPage />,
                validator: this.cInformationFurtherPageValidation,
            },
            {
                label: 'مشخصات بستگان',
                name: 'step 3',
                content: <CInformationFamilyPage />,
                validator: this.cInformationFamilyPageValidation,
            },
            {
                label: 'آپلود مدارک',
                name: 'step 4',
                content: <CUploadPage />,
            }
        ],
        constantCheck : true,
        otherGuestCheck: false,
        familyGuestCheck : false,
        isConstant: true,
        typeofResident : "constant",
        showDoneModal: false,
        personId: ''
    }

    checked = (e) => {
        const type = e.target.value
        this.setState({ typeofResident: type })

        switch (type) {
            case 'constant': {
                this.setState({constantCheck:true,otherGuestCheck:false,familyGuestCheck:false});
                this.setState({
                    steps: [
                        this.state.steps[0],
                        {
                            label: 'مشخصات اولیه',
                            name: 'step 1',
                            content: <CInformationPage />,
                            validator: this.constantInformationPageValidation,
                        },
                        {
                            label: 'مشخصات تکمیلی',
                            name: 'step 2',
                            content: <CInformationFurtherPage />,
                            validator: this.cInformationFurtherPageValidation,
                        },
                        {
                            label: 'مشخصات بستگان',
                            name: 'step 3',
                            content: <CInformationFamilyPage />,
                            validator: this.cInformationFamilyPageValidation,
                        },
                        {
                            label: 'آپلود مدارک',
                            name: 'step 4',
                            content: <CUploadPage />,
                        },
                    ]
                });
                break;
            }

            case 'otherGuest': {
                // مهمان متفرقه: فقط مشخصات اولیه + آپلود (کارت ملی)
                this.setState({constantCheck:false,otherGuestCheck:true,familyGuestCheck:false});
                this.setState({
                    steps: [
                        this.state.steps[0],
                        {
                            label: 'مشخصات اولیه',
                            name: 'step 1',
                            content: <OGInformationPage />,
                            validator: this.otherGuestValidation,
                        },
                        {
                            label: 'آپلود مدارک',
                            name: 'step 2',
                            content: <OGUploadPage />,
                        },
                    ]
                });
                this.context.handleTypeofResident(type)
                break;
            }

            case 'familyGuest': {
                // مهمان بستگان: مشخصات اولیه + میزبان + آپلود (بدون تکمیلی/بستگان)
                this.setState({constantCheck:false,otherGuestCheck:false,familyGuestCheck:true});
                this.setState({
                    steps: [
                        this.state.steps[0],
                        {
                            label: 'مشخصات اولیه',
                            name: 'step 1',
                            content: <FGInformationPage />,
                            validator: this.familyGuestValidation,
                        },
                        {
                            label: 'انتخاب میزبان',
                            name: 'step 2',
                            content: <FGInformationFamilyPage />,
                            validator: this.fgThirdPage,
                        },
                        {
                            label: 'آپلود مدارک',
                            name: 'step 3',
                            content: <FGUploadPage />,
                        },
                    ]
                });
                this.context.handleTypeofResident(type)
                break;
            }
        }
    }
    render() {
        return (
            <>
                <div style={{ direction: "ltr" }}>
                    <StepProgressBar
                        key={this.state.typeofResident}
                        startingStep={0}
                        contentClass={"register-container"}
                        previousBtnName={"قبلی"}
                        nextBtnName={"بعدی"}
                        submitBtnName={"ارسال"}
                        primaryBtnClass="next-btn"
                        secondaryBtnClass="previous-btn"
                        steps={this.state.steps}
                        onSubmit={this.handleSubmit}
                    />
                </div>
                <Modal centered show={this.state.showDoneModal} style={window.innerWidth > 768 ? {width: "25%", marginLeft: "50%", translate: "-50%"} : {width: "100%"}}>
                    <Modal.Header className={"bg-success text-cente d-flex justify-content-center"}>
                        <BsCheckCircleFill style={{color: "#fff"}} size={60}/>
                    </Modal.Header>
                    <Modal.Body className="px-4">
                        <div className="d-flex justify-content-center text-success" style={{fontSize: "2.5rem"}}>
                            موفق!
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex flex-row justify-content-between flex-column w-100 flex-lg-row">
                            <Link to={`/dashboard/people/${this.state.personId}`} className='btn  my-2 mx-0 btn-sm px-3 btn-success' onClick={() =>{this.handleGoToShow()}}>نمایش</Link>
                            <Link to={`/dashboard/booking/floor`} className='btn my-2  mx-0 btn-sm px-3' style={{backgroundColor: "#d7a85b"}} onClick={() =>{this.handleGoToShow()}}>ثبت تخت</Link>
                            <Link to="" className='btn btn-sm mx-0 my-2 px-3 btn-secondary ' onClick={() =>{this.handleCloseModal()}}>بستن</Link>
                        </div>
                    </Modal.Footer>
                </Modal>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={true}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </>
        );
    }


    handleCloseModal = () => {
        this.setState({showDoneModal:false})
        window.location.reload(false);
    }
    handleGoToShow = () => {
        this.setState({showDoneModal:false})
    }
    handleGoToSelectBed = () => {
        this.setState({showDoneModal:false})
    }

    handleSubmit = async()=>{
        document.getElementsByClassName("_2pGos _hsN1w next-btn")[0].style.pointerEvents = "none"
        if (this.state.typeofResident === 'familyGuest' || this.state.typeofResident === 'otherGuest') {
            const info = this.state.typeofResident === 'familyGuest'
                ? this.context.familyGuestInformation
                : this.context.otherGuestInformation;
            const depositReturn = (info.depositReturnDate || '').trim();
            if (depositReturn) {
                const todayJalali = new Date().toLocaleDateString('fa-IR-u-nu-latn', {
                    year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
                });
                if (depositReturn < todayJalali) {
                    toast.warning('تاریخ عودت ودیعه گذشته است');
                } else {
                    try {
                        const todayParts = todayJalali.split('/').map(Number);
                        const retParts = depositReturn.split(/[/\-]/).map(Number);
                        const todayObj = new DateObject({
                            year: todayParts[0], month: todayParts[1], day: todayParts[2],
                            calendar: persian, locale: persian_fa
                        });
                        const retObj = new DateObject({
                            year: retParts[0], month: retParts[1], day: retParts[2],
                            calendar: persian, locale: persian_fa
                        });
                        const diffDays = retObj.toUnix() - todayObj.toUnix();
                        if (diffDays >= 0 && diffDays <= 7 * 86400) {
                            toast.info('تاریخ عودت ودیعه کمتر از ۷ روز دیگر است');
                        }
                    } catch (e) { /* ignore parse */ }
                }
            }
        }
        switch (this.state.typeofResident) {
            case "constant" : {
                let newCharacteristic = {...this.context.constantInformationPage, ...this.context.constantInformationFurther, ...this.context.constantInformationFamily};
                newCharacteristic.health = this.context.constantInformationPage.health === 'true';

                const profileImg = this.context.constantUploadPage.find(({name}) => name === "personnelImg");
                if (profileImg !== undefined) {
                    newCharacteristic.profileId = profileImg.fileId;
                }
                let respondChar = ''
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .then(response => response.data)
                    .then((data) => {
                        respondChar = data
                    })
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondChar = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondChar = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })

                let person = {
                    residenceType: "resident",
                    accommodationType: "permanent",
                    characteristicId: respondChar.id,
                    files: this.context.constantUploadPage
                }

                let respondPerson = ''
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .then(response => response.data)
                    .then((data) => {
                        respondPerson = data
                    })
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondPerson = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondPerson = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })

                this.setState({personId: respondChar.id})
                axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${respondChar.id}`, {parentId: respondPerson.id}, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${respondChar.id}`, {parentId: respondPerson.id}, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${respondChar.id}`, {parentId: respondPerson.id}, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })
                this.context.handlePersonId(respondPerson.id, respondChar.id);
                break;
            }

            case "familyGuest": {
                let newCharacteristic = {...this.context.familyGuestInformation, ...this.context.familyGuestInformationFurther};
                newCharacteristic.personType = 'familyGuest'

                const profileImg = this.context.familyGuestUploadPage.find(({name}) => name === "personnelImg");

                if (profileImg !== undefined) {
                    newCharacteristic.profileId = profileImg.fileId;
                }

                let respondChar = ''
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .then(response => response.data)
                    .then((data) => {
                        respondChar = data
                    })
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondChar = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondChar = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })

                let person = {
                    residenceType: "resident",
                    accommodationType: "guest",
                    characteristicId: respondChar.id,
                    files: this.context.familyGuestUploadPage
                }

                let respondPerson = ''
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .then(response => response.data)
                    .then((data) => {
                        respondPerson = data
                    })
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondPerson = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondPerson = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })

                let guest = {
                    name: respondChar.fullName,
                    childId: respondPerson.id
                }

                const familyHostId = this.context.familyGuestInformationFamily.hostId;
                if (familyHostId) {
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/person/guest/${familyHostId}`, guest, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person/guest/${familyHostId}`, guest, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person/guest/${familyHostId}`, guest, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })
                }

                this.setState({personId: respondChar.id})
                this.context.handlePersonId(respondPerson.id, respondChar.id);
                break;
            }

            case  "otherGuest": {
                let newCharacteristic = {...this.context.otherGuestInformation, ...this.context.otherGuestInformationFurther};
                newCharacteristic.personType = 'otherGuest'
                const profileImg = this.context.otherGuestUploadPage.find(({name}) => name === "personnelImg");
                if (profileImg !== undefined) {
                    newCharacteristic.profileId = profileImg.fileId;
                }

                let respondChar = ''
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .then(response => response.data)
                    .then((data) => {
                        respondChar = data
                    })
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondChar = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic`, newCharacteristic, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondChar = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })

                let person = {
                    residenceType: "resident",
                    accommodationType: "guest",
                    characteristicId: respondChar.id,
                    files: this.context.otherGuestUploadPage
                }

                let respondPerson = ''
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .then(response => response.data)
                    .then((data) => {
                        respondPerson = data
                    })
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondPerson = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person`, person, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                            .then(response => response.data)
                                            .then((data) => {
                                                respondPerson = data
                                            })
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })

                await axios.put(`${API_BASE_URL}/api/v1/supervisor/characteristic/${respondChar.id}`, {parentId: respondPerson.id}, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic/${respondChar.id}`, {parentId: respondPerson.id}, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/characteristic/${respondChar.id}`, {parentId: respondPerson.id}, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })

                let guest = {
                    name: respondChar.fullName,
                    childId: respondPerson.id
                }

                const otherHostId = this.context.otherGuestInformationFamily.hostId;
                if (otherHostId) {
                await axios.post(`${API_BASE_URL}/api/v1/supervisor/person/guest/${otherHostId}`, guest, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                    .catch(async () => {
                        if (localStorage.getItem('role') === 'MANAGER') {
                            await axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person/guest/${otherHostId}`, guest, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                            await axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                                .then(async (response) => {
                                    if (response.headers["accesstoken"]) {
                                        localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                        await axios.post(`${API_BASE_URL}/api/v1/supervisor/person/guest/${otherHostId}`, guest, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    } else {
                                        window.location = '/'
                                    }
                                })
                        }
                    })
                }

                this.setState({personId: respondChar.id})
                this.context.handlePersonId(respondPerson.id, respondChar.id);
                break;
            }
        }
        this.setState({showDoneModal: true})

        toast(<div>
                <h4>اقامتگر با موفقیت ثبت شد</h4>
            </div>, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                // theme: "colored",
                className: "bg-success text-light",
            }
        )

        this.context.handleReset();
    }
}

export default MainRegister;